import { LocalShipping } from '@mui/icons-material';
import { grey } from '@mui/material/colors';
import { Box, Stack } from '@mui/material';
import { FormSection } from 'modules/sendCreditApplication/ui/sendApplicationForm/FormSection';
import { SendEquipmentFlyerForm } from 'modules/equipment/ui/components/SendEquipmentFlyerForm';

export const EquipmentPageSendEquipmentFlyer = ({ equipmentId }: { equipmentId: string }) => {
  return (
    <Stack gap="2rem" sx={{ borderRadius: '0.5rem', border: `1px solid ${grey[300]}` }}>
      <FormSection isExpanded={false} isExpandable title="Send Equipment Flyer" icon={<LocalShipping />}>
        <Box sx={{ p: 2 }}>
          <SendEquipmentFlyerForm equipmentId={equipmentId} />
        </Box>
      </FormSection>
    </Stack>
  );
};
